"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const label_1 = __importDefault(require("../typography/label"));
const styled_1 = __importDefault(require("../../styles/styled"));
const react_2 = require("@emotion/react");
const copyText = (value) => {
    const textarea = document.createElement('textarea');
    textarea.style.height = '0px';
    textarea.value = value ? value.toString() : '';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
};
const CopyButtonStyles = styled_1.default.button(({ wasClicked }) => {
    const theme = (0, react_2.useTheme)();
    return {
        color: wasClicked ? theme.colors.grey20 : theme.colors.azure,
        border: 'none',
        background: 'transparent',
        fontFamily: theme.text.bodyFontFamily,
        fontStyle: 'normal',
        fontWeight: 400,
        marginLeft: theme.space[3],
        fontSize: '14px',
        lineHeight: '18px',
        cursor: 'pointer',
    };
});
const CopyButton = (_a) => {
    var { value, label } = _a, props = __rest(_a, ["value", "label"]);
    const [wasClicked, setWasClicked] = (0, react_1.useState)(false);
    const onCopyClick = () => {
        copyText(value);
        setWasClicked(true);
        setTimeout(() => setWasClicked(false), 500);
    };
    return ((0, jsx_runtime_1.jsxs)(CopyButtonStyles, Object.assign({ onClick: () => onCopyClick(), wasClicked: wasClicked, "data-testid": props['data-testid'] }, { children: ["Copy ", (0, jsx_runtime_1.jsx)(label_1.default, Object.assign({ screenReaderOnly: true }, { children: label }))] })));
};
exports.CopyButton = CopyButton;
//# sourceMappingURL=copy_button.js.map